import { render, staticRenderFns } from "./lecture-form.vue?vue&type=template&id=0d5d3db8&scoped=true"
import script from "./lecture-form.vue?vue&type=script&lang=js"
export * from "./lecture-form.vue?vue&type=script&lang=js"
import style0 from "./lecture-form.vue?vue&type=style&index=0&id=0d5d3db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d3db8",
  null
  
)

export default component.exports